import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-language-picker',
  templateUrl: 'custom-language-picker.component.html',
  styleUrls: ['./custom-language-picker.page.scss']
})
export class CustomLanguagePickerComponent implements OnInit {
  selectedId: string;
  languageSet: ILangSetPayload[] = [];
  currentLangId: string;

  constructor(
    public popoverController: PopoverController,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {

    this.currentLangId = this.selectedId || this.translateService.currentLang;
    this.languageSet = [];
    this.languageSet = [
      {
        id: "es",
        name: "Español"
      },
      {
        id: "en",
        name: "English"
      }
    ];
  }

  selectLanguage(language: any) {
    this.popoverController.dismiss({
      data: language
    });
  }
}

export interface ILangSetPayload {
  id: string;
  name: string;
}